<template>
  <div id="SectionSupplierScope3">
    <UIContainer class="SectionSupplierScope3__container">
      <template #right>
        <img class="SectionSupplierScope3__image"
          :src="scope3Image"
          alt="Supplier & Scope 3"
          loading="lazy"
        />
      </template>

      <template #left>
        <div class="SectionSupplierScope3__content">
          <SectionTitle titleSize="sm">
            <template #title> Supplier & Scope 3 </template>

            <template #description>
              Collect better data without slowing procurement. Document
              assumptions today and upgrade seamlessly as suppliers improve.
            </template>
          </SectionTitle>

          <div class="SectionSupplierScope3__features">
            <div
              class="SectionSupplierScope3__feature"
              v-for="feature in features"
              :key="feature"
            >
              <UIIcon
                class="SectionSupplierScope3__feature-icon"
                name="checkCircleOutline"
              />
              <span>{{ feature }}</span>
            </div>
          </div>

          <!--<div class="SectionSupplierScope3__cta">
            <UIButton size="xl" theme="primary" buttonStyle="pale">
              Learn more

              <template #icon-after>
                <UIIcon name="arrowLink" />
              </template>
            </UIButton>
          </div>-->
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
// import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'
import scope3Image from '../assets/scope3/scope3.avif'

const features = [
  'Supplier portal',
  'Guided requests',
  'Fallback factors',
  'Coverage/quality scorecards',
  'Freight modeling (ISO 14083/GLEC)',
]
</script>

<style lang="scss" scoped>
#SectionSupplierScope3 {
  position: relative;

  .SectionSupplierScope3__image {
    display: none;

    @include md {
      display: block;
      margin-left: 6rem;
    }
  }

  .SectionSupplierScope3__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionSupplierScope3__features {
    display: grid;
    gap: 1rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionSupplierScope3__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionSupplierScope3__feature-icon {
    --size: 1.75rem;
  }

  .SectionSupplierScope3__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
